import React from "react";
import s from "./index.css";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import html2canvas from "html2canvas";
import { convertCanvasToImage, saveFile } from "../../../utils";
import Button from "../components/Button";



class P43 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dataset: []
    };
  }
  // 截图并下载
  captureAndDownload = () => {
    // 通过class选择器获取所有要截图的div
    const divs = document.querySelectorAll(".PageBox");
    const w = divs.offsetWidth;
    const h = divs.offsetHeight;

    Array.from(divs).forEach((div, index) => {
      html2canvas(div, {
        useCORS: true,
        scale: 2, // 将画布的尺寸放大到原始尺寸的两倍
        logging: false,
        foreignObjectRendering: true,
      }).then((canvas) => {
        const src = convertCanvasToImage(canvas).src;
        saveFile(src, `热梗`);

        // link.click();
      });
    });
  };

  render() {
    const { dataset } = this.state;
    return (
      <div className={s.appBox}>
        <Button
          type="primary"
          onClick={this.captureAndDownload}
          style={{ margin: "10px 10px ", display: "inline" }}
        >
          下载
        </Button>

        <div
          className="PageBox"
          style={{
            width: "680px",
            height: "965px",
          }}
        >
          <div className={s.InnerBox}>
            <div className={s.textBox}>
              <span contentEditable>社交塑料瓶</span>
            </div>
            <div className={s.textBox}>
              <span contentEditable>潜龙必须入渊了</span>
            </div>
            <div className={s.textBox}>
              <span contentEditable>双向崩赴</span>
            </div>
            <div className={s.textBox}>
              <span contentEditable>正式确诊为夏人</span>
            </div>
            <div className={s.textBox}>
              <span contentEditable>你可能不认识我，但你一定XXX</span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(s)(P43);



// WEBPACK FOOTER //
// src/routes/visualChart/P43/index.js